<template>
    <div>
        <fade-transition origin="center" mode="out-in" :duration="250">
            <div class="share_pop" @click="close" v-if="show">
                <div class="share_content">
                    <div class="share_icon"></div>
                    <div class="share_word">点击右上角立即分享</div>
                </div>
            </div>
        </fade-transition>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
    name: 'share',
    components: {
        FadeTransition,
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        open() {
            this.show = true
        },
        close() {
            this.show = false
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.share_pop {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .4);

    .share_content {
        background: url(https://cdncos.aigupiao.com/assets/wap/img/sharebox-b.png) no-repeat;
        width: 186.5px;
        height: 66.5px;
        right: 26.5px;
        position: absolute;
        top: 6.5px;

        .share_icon{
            background: url(https://cdncos.aigupiao.com/assets/wap/img/check@2x.png) no-repeat;
            background-size: cover;
            width: 24.5px;
            height: 34.5px;
            float: left;
            margin: 19.5px 4px 12.5px 10.5px;
        }
        .share_word{
            margin: 26.5px 0px 19px 0px;
            font-size: 15px;
            float: left;
            color: #FF3534;
            line-height: 21px;
        }

    }
}
</style>